module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba-funabashi-point2-1@2x-caf50b8778a39345835077037369006f.webp";